import React from "react";
import DraggerUpload from "./draggerupload";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LicenceDetail from "./licenceDetail";
import { Button } from "antd";
import { Link } from 'react-router-dom';

const documentverificationupload = () => {
  return (
    <div className="document-upload">
      <div className="title">Verification Documents</div>

      <div className="upload  d-flex h-100 justify-content-center text-center align-items-center ">
        <Row>
          <Col lg={6}>
            <DraggerUpload className="antupload" title="Front Side" />
          </Col>
          <Col lg={6} className="antupload-back " >
            <DraggerUpload className="antupload-back " title="Back Side" />
          </Col>
        </Row>
      </div>

      <div className="check-licence-wrap">
        <p>
          Skycars manually checks each licence. Please ensure the following are
          clearly visible in the licence images:
        </p>

        <div className="licencedetail">
          <LicenceDetail />
        </div>

        <p className="pt-4">
          In case your license has these details on different sides or pages,
          please upload all images. Any discrepancy or missing information will
          cause booking cancellation.
        </p>
       
      </div>

      <div className=" save-button    justify-content-center align-items-center text-center ">
      <Link to="/verifieddocument">
        <Button type="primary " className="save-documents-btn ">
          SAVE DOCUMENTS
        </Button>
        </Link>
      </div>

   
    </div>
  );
};

export default documentverificationupload;
